export default "__VITE_ASSET__BQtcktXZ__"